import { useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/FirebaseCredential";
import { setSession, clearSession } from "../features/sessionSlice";
import { useAppDispatch } from "./hooks";

const useSessionSync = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const sessionRef = doc(db, "sessions", user.uid);
          const sessionSnap = await getDoc(sessionRef);

          if (sessionSnap.exists()) {
            const sessionData = sessionSnap.data();
            dispatch(
              setSession({
                uid: user.uid,
                company_id: sessionData.company_id,
                mapped_branch_id:
                  sessionData.branch_id || sessionData.mapped_branch_id || [],
                roles: sessionData.roles || [],
                role_type: sessionData.role_type,
              })
            );
          }
        } catch (error) {
          console.error("Error fetching session data:", error);
        }
      } else {
        dispatch(clearSession());
      }
    });

    return () => unsubscribe(); // Cleanup on unmount
  }, [dispatch]);
};

export default useSessionSync;
